module.exports = __webpack_public_path__ + "img/ltktrendingcreators-4x.0865d1c.jpg";